/**
 * Method to decide whether render recaptcha badge or not
 */
const decideBadge = () => {
  const IS_BADGE_HIDDEN = false;
  if (IS_BADGE_HIDDEN !== true) {
    return;
  }

  hideBadge();
};

const hideBadge = () => {
  const styleContainer = document.createElement("style");
  styleContainer.setAttribute("id", "g-recaptcha-badge-style");
  styleContainer.innerHTML = ".grecaptcha-badge{visibility:hidden !important;}";
  document.head.appendChild(styleContainer);
};

const showBadge = () => {
  if (document.getElementById("g-recaptcha-badge-style")) {
    const styleContainer = document.getElementById("g-recaptcha-badge-style");
    document.head.removeChild(styleContainer);
  }
};

/**
 * ACTION NAME CONVENTION TO EXECUTE GOOGLE RECAPTCHA V3
 * This convention probably can help to manage list of actions taken on google recaptcha admin console
 * <module-name>_<submodule-name>_<action-type>
 * action-type can be vary (submission, initiation, etc.)
 */
export default {
  install(Vue, options) {
    const store = options.store;
    const DEFAULT_SITE_KEY =
      store.state.config.configurationData.googleReCaptchaSiteKey;

    decideBadge();

    /**
     * Method to detect if grecaptcha already attached or not
     * @param {*} callback
     */
    const captchaOnReadyCallback = callback => {
      return new Promise((resolve, reject) => {
        try {
          // if (
          //   store.state.config.configurationData.environment == "prd" ||
          //   store.state.config.configurationData.environment == "uat"
          // ) {
          window.grecaptcha.enterprise.ready(function() {
            callback();
            resolve();
          });
          // } else {
          //   window.grecaptcha.ready(function() {
          //     callback();
          //     resolve();
          //   });
          // }
        } catch (e) {
          reject(e);
        }
      });
    };

    /**
     * Method to inject google recaptcha script into <head>
     * @param {*} callback
     * @param {*} siteKey of google recaptcha V3
     */
    const loadScript = (callback, siteKey) => {
      // Create script element
      const scriptElement = document.createElement("script");
      scriptElement.setAttribute("recaptcha-v3-script", "");
      scriptElement.setAttribute("id", "g-recaptcha-script");

      let scriptBase;
      // if (
      //   store.state.config.configurationData.environment == "prd" ||
      //   store.state.config.configurationData.environment == "uat"
      // )
      scriptBase = "https://www.google.com/recaptcha/enterprise.js";
      // else scriptBase = "https://www.google.com/recaptcha/api.js";

      scriptElement.src = scriptBase + `?render=${siteKey}`;

      return new Promise((resolve, reject) => {
        scriptElement.addEventListener(
          "load",
          async () => {
            await captchaOnReadyCallback(callback);
            resolve(scriptElement);
          },
          false
        );
        scriptElement.onerror = error => {
          reject(error);
        };
        document.head.appendChild(scriptElement);
      });
    };

    Vue.prototype.$recaptcha = {
      showBadge: showBadge,
      hideBadge: hideBadge,
      /**
       * Method to load window.grecaptcha
       * @param {*} actionName nullable. If passed will immediately call execute to generate token.
       * @param {*} callback
       * @param {*} siteKey of google recaptcha V3
       */
      load: function(
        actionName,
        callback = () => {},
        siteKey = DEFAULT_SITE_KEY
      ) {
        return new Promise((resolve, reject) => {
          // if (
          //   process.env.NODE_ENV === "development" ||
          //   store.state.config.configurationData.environment == "dev"
          // )
          //   resolve(null);
          // else {
          if (!document.getElementById("g-recaptcha-script")) {
            loadScript(callback, siteKey)
              .then(async () => {
                showBadge();
                if (actionName) {
                  const token = await window.Vue.prototype.$recaptcha.execute(
                    actionName
                  );
                  resolve(token);
                } else {
                  resolve(window.Vue.prototype.$recaptcha);
                }
              })
              .catch(e => {
                reject(e);
              });
          } else {
            showBadge();
            if (actionName) {
              window.Vue.prototype.$recaptcha
                .execute(actionName)
                .then(token => {
                  resolve(token);
                });
            } else {
              resolve(window.Vue.prototype.$recaptcha);
            }
          }
          // }
        });
      },
      /**
       * Method to run execute function under window.grecaptcha
       * @param {*} actionName name of the action that will be called when run execute function
       */
      execute: function(actionName) {
        return new Promise((resolve, reject) => {
          if (window.grecaptcha) {
            // if (
            //   store.state.config.configurationData.environment == "prd" ||
            //   store.state.config.configurationData.environment == "uat"
            // ) {
            window.grecaptcha.enterprise
              .execute(DEFAULT_SITE_KEY, { action: actionName })
              .then(function(recaptchaTokenResponse) {
                resolve(recaptchaTokenResponse);
              })
              .catch(e => {
                reject(e);
              });
            // } else {
            //   window.grecaptcha
            //     .execute(DEFAULT_SITE_KEY, { action: actionName })
            //     .then(function(recaptchaTokenResponse) {
            //       resolve(recaptchaTokenResponse);
            //     })
            //     .catch(e => {
            //       reject(e);
            //     });
            // }
          } else {
            reject("Google reCAPTCHA haven't initiated yet.");
          }
        });
      }
    };
  }
};
